// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';
import ProjectActions from '../actions/project.actions';
import GtmActions from '../actions/gtmapi.actions';
import WizardAction from '../actions/wizard.actions';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';
import MdAddCircleOutline from 'react-icons/lib/md/add-circle-outline';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import qs from 'query-string';
import { routerActions } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import Button from '../common/ButtonComp';
import Checkbox from 'react-toolbox/lib/checkbox';
import ArrowRight from 'react-icons/lib/md/keyboard-arrow-right';
import './SelectGtmPropertyComp.css';

class CreateUploadPropertyComp extends Component {
  state: {
    accountId: string,
    containerId: string,
    containerName: string,
    publicId: string,
    acceptedToc: boolean,
    workspaceId: string
  };
  constructor(props) {
    super(props);
    const { project, me } = props;
    this.state = {
      accountId: project && project.gtm && project.gtm.accountId,
      containerId: project && project.gtm && project.gtm.containerId,
      workspaceId: project && project.gtm && project.gtm.workspaceId,
      containerName: project && project.gtm && project.gtm.containerName,
      publicId: project && project.gtm && project.gtm.publicId,
      acceptedToc: me.user.tocAccepted || false
    };
  }

  selectAccount(account) {
    const {
      gtmApiActions: { getContainers },
      project
    } = this.props;
    this.setState({ accountId: account.accountId, containerId: undefined });
    getContainers({ id: project._id, accountId: account.accountId });
  }

  selectContainer(container) {
    const {
      gtmApiActions: { getWorkspaces },
      project
    } = this.props;
    const { accountId } = this.state;

    this.setState({
      containerId: container.containerId,
      containerName: container.name,
      publicId: container.publicId
    });
    getWorkspaces({ id: project._id, accountId, containerId: container.containerId });
  }

  selectWorkspace(workspace) {
    if (workspace) return this.setState({ workspaceId: workspace.workspaceId });
    this.setState({ workspaceId: undefined });
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  toggleTOC = () => {
    const {
      me: { user }
    } = this.props;

    if (user.tocAccepted) {
      return;
    }

    this.setState({
      acceptedToc: !this.state.acceptedToc
    });
  };

  save = () => {
    const {
      query: { idx = 0 },
      projectActions,
      project
    } = this.props;
    const { accountId, containerId, containerName, publicId } = this.state;
    projectActions.saveGtmSettings({
      idx,
      id: project._id,
      accountId,
      containerId,
      containerName,
      publicId
    });
  };

  goNext = () => {
    const {
      query: { idx = 0 },
      routerActions
    } = this.props;
    const { accountId } = this.state;

    routerActions.push(`select-web-property?idx=${idx}`);
  };

  componentDidMount() {
    const {
      gtmApiActions: { getGtmAccounts, getContainers, getWorkspaces },
      project
    } = this.props;

    getGtmAccounts({ id: project._id });

    if (project.gtm && project.gtm.accountId)
      getContainers({ id: project._id, accountId: project.gtm.accountId });
    if (project.gtm && project.gtm.containerId)
      getWorkspaces({
        id: project._id,
        accountId: project.gtm.accountId,
        containerId: project.gtm.containerId
      });
  }

  handleChangeDropdown = (tokenId) => {
    const {
      wizardActions: { selectAccount },
      project
    } = this.props;

    if (tokenId === 'add') {
      window.location.href = `/auth/with-google/add?projectId=${project._id}&projectIndex=${
        project.index
      }`;
      return;
    }

    this.setState({ accountId: undefined, containerId: undefined, workspaceId: undefined });
    selectAccount({
      tid: tokenId,
      projectId: project._id,
      accountId: project.accountId
    });
  };

  render() {
    const {
      translate,
      project,
      gtmAccountsUpdating,
      gtmAccountsError,
      gtmAccounts,
      containersUpdating,
      containersError,
      containers,
      workspacesUpdating,
      workspacesError,
      workspaces,
      me,
      gtmSaving
    } = this.props;
    const { accountId, containerId, acceptedToc } = this.state;
    const isGtmSelected = !!project.gtm && project.gtm.accountId;

    const isUploadAccountExists = !!project.webPropertyId;
    let originalPropertyName = 'Log Hero';

    const accountsUpdatingProgress = gtmAccountsUpdating && (
      <ProgressBar type="linear" mode="indeterminate" />
    );
    const containersUpdatingProgress = containersUpdating && (
      <ProgressBar type="linear" mode="indeterminate" />
    );
    const workspacesUpdatingProgress = workspacesUpdating && (
      <ProgressBar type="linear" mode="indeterminate" />
    );

    const accountsErrorMessage = (
      <p>
        {translate('wizard.select_analytics.account_access_error', {
          appAccEmail: project.accessEmail,
          projectIndex: project.index,
          projectId: project._id,
          isWebProperty: ''
        })}
      </p>
    );
    const containersErrorMessage = (
      <p>
        {translate('wizard.select_analytics.accounts_permissions_error', {
          appAccEmail: project.accessEmail
        })}
      </p>
    );
    const workspacesErrorMessage = (
      <p>
        {translate('wizard.select_analytics.accounts_permissions_error', {
          appAccEmail: project.accessEmail
        })}
      </p>
    );

    const createNewAccount = (
      <Row start="xs" className="space-big-bottom">
        <Col xs={5}>
          <h5>{translate('wizard.gtm.accounts')}</h5>
          <div className="select-list">
            {accountsUpdatingProgress}
            {!gtmAccountsUpdating &&
              !gtmAccountsError &&
              gtmAccounts.map(AnalyticsAccountsSelectList.bind(this))}
          </div>
        </Col>
        <Col xs={6}>
          <h5>{translate('wizard.gtm.containers')}</h5>
          <div className="select-list">
            {containersUpdatingProgress}
            {(!gtmAccounts || !gtmAccounts.length) &&
              (!gtmAccountsUpdating && !gtmAccountsError) && (
                <div className="gtmAccountsNotExists">
                  {translate('wizard.gtm.accounts_not_exists', {
                    email: project.accessEmail
                  })}
                </div>
              )}
            {containersError || gtmAccountsError
              ? accountsErrorMessage || containersErrorMessage
              : !containersUpdating && containers.map(ContainersSelectList.bind(this))}
          </div>
        </Col>
      </Row>
    );

    const next = (
      <Button big primary onClick={this.goNext.bind(this)}>
        {translate('app.next')}
      </Button>
    );
    const save = (
      <Button
        big
        primary
        loading={gtmSaving}
        disabled={!accountId || !containerId || !acceptedToc}
        onClick={this.save.bind(this)}
      >
        {translate('app.choose')}
      </Button>
    );

    const accountList = me.user.googleAccounts.map(({ _id, email }) => ({
      value: _id,
      label: email
    }));

    accountList.push({
      value: 'add',
      label: translate('wizard.gtm.change_account')
    });

    const selectedAccount = me.user.googleAccounts.find(({ _id }) => {
      return project.accessId === _id;
    });

    const toc = !me.user.isWizardDone && (
      <div className="wizard-property_setup-toc">
        <Row>
          <Col xsOffset={3} xs={8}>
            <Checkbox
              checked={acceptedToc}
              disabled={me.user.tocAccepted}
              theme={{ check: 'toc-checkbox', checked: 'toc-checkbox-checked' }}
              onChange={this.toggleTOC}
            >
              {translate('wizard.gtm.toc_agree')}
            </Checkbox>
          </Col>
        </Row>
      </div>
    );

    return (
      <div className="wizard-upload_create">
        <h1>{translate('wizard.gtm.choose_container')}</h1>
        <div className="space-big-bottom account-lead-text">
          {translate('wizard.gtm.create_mirror_user_for')}

          {project.gtm && project.gtm.accountId ? (
            <strong> {project.accessEmail}</strong>
          ) : (
            <Col className="accounts-dropdown-wrapper" xs={5}>
              <Dropdown
                auto
                onChange={this.handleChangeDropdown}
                className={'accounts-dropdown'}
                template={DropdownAccountItem(selectedAccount && selectedAccount._id)}
                source={accountList}
                value={selectedAccount && selectedAccount._id}
              />
            </Col>
          )}

          {translate('wizard.gtm.create_mirror_select_account')}
        </div>
        {selectedAccount && createNewAccount}
        {toc}
        <div className="kwh-button-group">
          {project.gtm && project.gtm.containerId ? next : save}
        </div>
      </div>
    );
  }
}

function DropdownAccountItem(selectedValue) {
  return ({ value, label }) => {
    return (
      <div className={`dropdown-container ${value === 'add' && 'dropdown-change-element'}`}>
        <div className={`content-element ${value === selectedValue && 'active'}`}>{label}</div>
      </div>
    );
  };
}

function AnalyticsAccountsSelectList(account, i) {
  const { project } = this.props;
  const { accountId } = this.state;
  const isGtmSelected = !!project.gtm && project.gtm.accountId;
  const isActiveAccount =
    (accountId && accountId === account.accountId) ||
    (isGtmSelected && project.gtm.accountId === account.accountId);

  const itemClassName = [
    'select-list_item',
    isActiveAccount ? 'active' : '',
    isGtmSelected && !isActiveAccount ? 'select-list_faded' : ''
  ].join(' ');
  const onClickAction =
    !isGtmSelected && !isActiveAccount && this.selectAccount.bind(this, account);
  return (
    <div className={itemClassName} onClick={onClickAction} key={i}>
      {account.name} <ArrowRight className="select-list_arrow" />
    </div>
  );
}

function ContainersSelectList(container, i) {
  const { project, containerIds } = this.props;
  const { containerId } = this.state;
  const isGtmSelected = !!project.gtm && project.gtm.containerId;
  const isActiveAccount =
    (containerId && containerId === container.containerId) ||
    (isGtmSelected && project.gtm.containerId === container.containerId);

  const isUnique = !~containerIds.indexOf(container.containerId);

  const itemClassName = [
    'select-list_item',
    isActiveAccount ? 'active' : '',
    (isGtmSelected && !isActiveAccount) || !isUnique ? 'select-list_faded' : ''
  ].join(' ');
  const onClickAction =
    !isGtmSelected && !isActiveAccount && isUnique && this.selectContainer.bind(this, container);
  return (
    <div className={itemClassName} onClick={onClickAction} key={i}>
      <span>{container.name}</span> <small>{container.publicId}</small>{' '}
      <ArrowRight className="select-list_arrow" />
    </div>
  );
}

function WorkspacesSelectList(workspace, i) {
  const { project } = this.props;
  const { workspaceId } = this.state;
  const isGtmSelected = !!project.gtm && project.gtm.workspaceId;
  const isActiveAccount =
    (workspaceId && workspaceId === workspace.workspaceId) ||
    (isGtmSelected && project.gtm.workspaceId === workspace.workspaceId);

  const itemClassName = [
    'select-list_item',
    isActiveAccount ? 'active' : '',
    isGtmSelected && !isActiveAccount ? 'select-list_faded' : ''
  ].join(' ');
  const onClickAction =
    !isGtmSelected && !isActiveAccount && this.selectWorkspace.bind(this, workspace);
  return (
    <div className={itemClassName} onClick={onClickAction} key={i + 1}>
      {workspace.name}
    </div>
  );
}

function getAccountById({ accounts, accountId }) {
  const matchedAccount = accounts.filter((account) => account.id === accountId);
  return matchedAccount && matchedAccount[0];
}

function mapStateToProps(state) {
  const {
    routing: {
      location: { search }
    },
    gtm: {
      gtmAccountsUpdating,
      gtmAccountsError,
      gtmAccounts,
      containersUpdating,
      containersError,
      containers,
      workspacesUpdating,
      workspacesError,
      workspaces,
      gtmSaving
    }
  } = state;
  const query = search ? qs.parse(search) : { idx: 0 };
  const { projects = [] } = state.me.user;
  const containerIds = projects.map((p) => p && p.gtm && p.gtm.containerId).filter((c) => !!c);

  return {
    me: state.me,
    wizard: state.wizard,
    translate: getTranslate(state.locale),
    project: projects[query.idx],
    query,
    containerIds,
    gtmAccountsUpdating,
    gtmAccountsError,
    gtmAccounts,
    containersUpdating,
    containersError,
    containers,
    workspacesUpdating,
    workspacesError,
    workspaces,
    gtmSaving
  };
}

function mapDispatchToProps(dispatch) {
  return {
    projectActions: bindActionCreators(ProjectActions, dispatch),
    gtmApiActions: bindActionCreators(GtmActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    wizardActions: bindActionCreators(WizardAction, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUploadPropertyComp);



// WEBPACK FOOTER //
// ./src/wizard/SelectGtmPropertyComp.js